/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Button, Form, Input, Modal, ModalHeader, ModalBody, ModalFooter, Label } from 'reactstrap';


// context imports
import { ThemeContext } from '../../../contexts/ThemeContext'

// service imports
import ProviderService from '../../../services/ProviderService';
import GeneralService from '../../../services/GeneralService';

// local imports
import CustomCheckbox from './CustomCheckbox';
import Session from '../../user/Session';

const RescheduleSession = props => {

    // states
    const [sessions, setSessions] = useState(props.sessions);
    const [modal, setModal] = useState({ isVisible: false, message: '' });
    const [isLoading, setIsLoading] = useState(false);

    // contexts
    const { theme, fontWeight, fontSize, colors } = useContext(ThemeContext);

    // utility functions
    const toggleCheckedSessions = index => {
        try {
            let tempArray = [...sessions];
            tempArray[index].reschedule = !tempArray[index].reschedule;
            setSessions(tempArray);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider RescheduleSession toggleCheckedSessions', 'Error in try catch block', err.stack);
        }
    }


    // handle functions
    const handleSubmit = e => {
        e.preventDefault();
        try {
            setIsLoading(true);
            if (modal.message === '') {
                Alert.error("Please enter a message", {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading(false);
                return;
            }
            let sessionList = [];
            sessions.map((item) => {
                if (item.reschedule)
                    sessionList.push({ id: item._id, date: item.date, time: item.time, message: modal.message });
            });
            ProviderService.requestRescheduling(sessionList)
                .then(data => {
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsLoading(false);
                    props.closeModel();
                })
                .catch(error => {
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsLoading(false);
                });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading(false);
            GeneralService.logError('at Provider RescheduleSession handleSubmit', 'Error in try catch block', err.stack);
        }
    }

    return (
        // <div className="p-3 mt-3" style={theme.card}>
        //     <div className="row px-3" style={{cursor: "pointer"}}>
        //         <span style={theme.headingBold}>Sessions Scheduled on this day</span>
        //         <span className="ml-auto" style={theme.headingRegular}>
        //         {
        //             <span className="ml-3"><i className="fas fa-times"></i></span>
        //         }
        //         </span>
        //     </div>
        //     <hr />
        <div>
            <Form>
                <p style={{ fontWeight: fontWeight.medium }}>Select the sessions to send the respective clients a mail to reschedule the session</p>
                <p style={{ fontSize: fontSize.md }}>Total - {sessions.length}</p>
                {
                    sessions.map((item, index) => (
                        <div key={index} className="row">
                            <div className="col-1 text-center">
                                <CustomCheckbox isChecked={item.reschedule} toggleIsChanged={() => toggleCheckedSessions(index)} />
                            </div>
                            <div className="col-11 pl-0">
                                <Session isOpen={true} detail={item} mode="reschedule" index={index} />
                            </div>
                        </div>
                    ))
                }
                <br />
                <Button type="submit" style={theme.formSubmit} onClick={(e) => { e.preventDefault(); setModal({ ...modal, isVisible: true }); }}>Ask to Reschedule</Button>
            </Form>
            <Modal size="lg" isOpen={modal.isVisible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setModal({ isVisible: false })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Your message to client(s)</span></ModalHeader>
                <ModalBody>
                    <Label>Please enter reason for rescheduling, this message will be sent to your client.</Label>
                    <Input type="textarea" id="message" style={{ height: '180px' }} name="message" onChange={(e) => setModal({ ...modal, message: e.target.value })} />
                </ModalBody>
                <ModalFooter>
                    <Button type="button" style={theme.formButton} className="btn btn-danger" onClick={handleSubmit} disabled={isLoading}>
                        {isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Save
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default RescheduleSession;